<template>
  <BasicLayout :left="left" :middle="middle" :right="right">
    <template v-slot:right_view>
      <div class="h-outTabs">
        <ejs-tab ref="tabObj" id="tab_orientation" heightAdjustMode="Auto" :selecting="disableSelecting">
          <e-tabitems>
            <e-tabitem :header="headerText0" content="#idv1"></e-tabitem>
            <e-tabitem :header="headerText1" content="#idv2"></e-tabitem>
            <e-tabitem :header="headerText2" content="#idv3"></e-tabitem>
          </e-tabitems>
        </ejs-tab>
        <div id="idv1" style="display: none">
          <accountStrategy></accountStrategy>
        </div>
        <div id="idv2" style="display: none">
          <passwordStrategy></passwordStrategy>
        </div>
        <div id="idv3" style="display: none">
          <timeStrategy></timeStrategy>
        </div>
      </div>
    </template>
  </BasicLayout>
</template>

<script>
import passwordStrategy from '../../components/security/strategyManager/PasswordStrategy';
import timeStrategy from '../../components/security/strategyManager/TimeStrategy';
import accountStrategy from '../../components/security/strategyManager/AccountStrategy';
import BasicLayout from "../../layouts/BasicLayout";
import CustomDialog from "../../components/common/CustomDialog";

export default {
  name: "strategyManager",
  data() {
    return {
      left: { show: false, name: "" },
      middle: { show: false, name: "" },
      right: { show: true, crumb: `${this.$t('Security.securityManage')}`+'/' + `${this.$t('Security.authorityManage')}` + '/' + `${this.$t('Security.strategyManage')}` },
      headerText0: { text: `${this.$t('Security.userStrategy')}` },
      headerText1: { text: `${this.$t('Security.pwdStrategy')}` },
      headerText2: { text: `${this.$t('Security.timeStrategy')}` },
    };
  },
  components:{
    passwordStrategy,
    timeStrategy,
    accountStrategy,
    BasicLayout,
    CustomDialog
  },
  methods: {
    disableSelecting(e) {
      if (e.isSwiped) {
        e.cancel = true;
      }
    }
  }
};
</script>
